import React, { useState } from "react";
import styles from "./aboutThisProject.module.css";
import { Link, useLocation } from "react-router-dom";

function AboutThisProject() {
  const [showAboutUsTag, setShowAboutUsTag] = useState("");
  const location = useLocation().pathname;
  return (
    <>
      {location !== "/about" ? (
        <div
          className={styles.aboutUsTag + " d-flex " + styles[showAboutUsTag]}
        >
          <div
            onClick={() =>
              setShowAboutUsTag(showAboutUsTag ? "" : "showAboutUsTag")
            }
            className={
              styles.aboutUsTagArrow +
              " d-flex justify-content-center align-items-center px-3"
            }
          >
            <i
              className={
                showAboutUsTag ? "bi bi-caret-right" : "bi bi-caret-left-fill"
              }
            ></i>
          </div>
          <div className="d-flex justify-content-center align-items-center mx-auto">
            <Link to="/about" onClick={() => setShowAboutUsTag("")}>
              Sobre este proyecto
            </Link>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default AboutThisProject;
